"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InspectionObjectSchema = void 0;
const zod_1 = require("zod");
exports.InspectionObjectSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    object: zod_1.z.literal('inspection'),
    title: zod_1.z.string(),
    description: zod_1.z.string().nullable(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
    created_at: zod_1.z.date().openapi({ type: 'string', format: 'date-time' }),
})
    .openapi('InspectionObject');
// export const InspectionCreatePayloadSchema = z
//     .object({
//         ...ThreadCreatePayloadSchema._def
//     })
//     .openapi('InspectionCreatePayload');
//# sourceMappingURL=inspectionSchema.js.map